import { render, staticRenderFns } from "./CampaignsCharges.vue?vue&type=template&id=3e7ea27b"
import script from "./CampaignsCharges.vue?vue&type=script&lang=js"
export * from "./CampaignsCharges.vue?vue&type=script&lang=js"
import style0 from "./CampaignsCharges.vue?vue&type=style&index=0&id=3e7ea27b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports